export const getTokenFromQuery = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get('token');
};
